import { store } from '@/store';
const Login = () => import('@/views/common/renewal/Login');
const MainHeader = () => import('@/components/MainHeader');
const Refusal = () => import('@/views/common/renewal/Refusal');
const Calculator = () => import('@/views/common/renewal/Calculator');
const Review = () => import('@/views/common/insure/renewal/Review');
const PasMultipleEdit = () => import('@/views/common/insure/renewal/PasMultipleEdit');
const PasEdit = () => import('@/views/common/insure/renewal/PasEdit');
const ApplicantEdit = () => import('@/views/common/insure/renewal/ApplicantEdit');
const AssuredEdit = () => import('@/views/common/insure/renewal/AssuredEdit');
const Otp = () => import('@/views/common/renewal/Otp');

export default [
    {
        path: '/:type(car|motor)/renewal',
        name: 'RenewalLogin',
        components: {
            default: Login,
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {
            next();
        }
    },
    {
        /* 4.7 桌機-續保-保費試算結果(可調整商品組合)結果 */
        path: '/:type(car|motor)/renewal/calculator',
        name: 'RenewalCalculator',
        components: {
            default: Calculator,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.state.policy.isRenew) {
                return next(`/${to.params.type}/renewal`);
            }
            next();
        }
    },
    {
        /* 一般流程保單確認 */
        path: '/:type(car|motor)/renewal/review',
        name: 'RenewalReview',
        components: {
            default: Review,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.state.policy.isRenew) {
                return next(`/${to.params.type}/renewal`);
            }
            next();
        }
    },
    {
        /* 無法續保 */
        path: '/:type(car|motor)/renewal/refusal',
        name: 'RenewalRefusal',
        components: {
            default: Refusal,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.state.policy.isRenew) {
                return next(`/${to.params.type}/renewal`);
            }
            next();
        }
    },
    {
        /*  修改被保險人暨要保人資料 */
        path: '/:type(car|motor)/renewal/applicant-edit',
        name: 'RenewalApplicantEdit',
        components: {
            default: ApplicantEdit,
        },
        beforeEnter: (to, from, next) => {
            if (!store.state.policy.isRenew) {
                return next(`/${to.params.type}/renewal`);
            }
            next();
        }
    },
    {
        // step-3 修改被保險人資料
        path: '/:type(car|motor)/renewal/assured-edit',
        name: 'RenewalAssuredEdit',
        components: {
            default: AssuredEdit,
        },
        beforeEnter: (to, from, next) => {
            if (!store.state.policy.isRenew) {
                return next(`/${to.params.type}/renewal`);
            }
            next();
        }
    },
    {
        // step-3 修改 56 PAS - 多人
        path: '/:type(car|motor)/renewal/pas-multiple-edit',
        name: 'RenewalPasMultipleEdit',
        components: {
            default: PasMultipleEdit,
        },
        beforeEnter: (to, from, next) => {
            if (!store.state.policy.isRenew) {
                return next(`/${to.params.type}/renewal`);
            }
            next();
        }
    },
    {
        // step-3 修改 166 / 147 PAS
        path: '/:type(car|motor)/renewal/pas-edit',
        name: 'RenewalPasEdit',
        components: {
            default: PasEdit,
        },
        beforeEnter: (to, from, next) => {
            if (!store.state.policy.isRenew) {
                return next(`/${to.params.type}/renewal`);
            }
            next();
        }
    },
    {   /* 查詢結果 */
        path: '/:type(car|motor)/renewal/otp',
        name: 'RenewalOtp',
        components: {
            default: Otp,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.state.policy.isRenew) {
                return next(`/${to.params.type}/renewal`);
            } else if (!store.getters['otp/loginOtpCodeAvailable'] && !store.getters['otp/registerOtpCodeAvailable']) {
                return next(`/${to.params.type}/renewal/review`);
            }
            next();
        }
    }
];